import { getRequestConfiguration } from "../utils/headerHelper";
import Axios from "../utils/http-request";
import { AxiosErrorResponse } from "../interface/api_request";

export const apiGetMedics = async (page: string, filter: string) => {
  const cfg = await getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/admin/medics?page=${page}&${filter}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicById = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/medic/${values.medicId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicStats = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/medic/${values.medicId}/analytics`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicIdTimesheet = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/${values.medicId}/timesheets`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicAppraisal = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/${values.medicId}/appraisals`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicMobilityScore = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/medic/${values.medicId}/mobility`;

    return await Axios.get(uri);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicRequest = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/medic/${values.medicId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicApplication = async (values: { medicId: string }) => {
  try {
    const uri = `/admin/medics/medic/${values.medicId}`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetMedicByIdEmployments = async (values: {
  medicId: string;
}) => {
  try {
    const uri = `/admin/medics/${values.medicId}/employments`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiGetGeneralMedicAnalytics = async () => {
  try {
    const uri = `/admin/medics/general-analytics`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

export const apiVerifyMedicById = async (values: { medicId: string }) => {
  const formData = new URLSearchParams();
  formData.append("verification", "vetted");

  try {
    const uri = `/admin/medics/medic/${values.medicId}/verify`;
    const cfg = await getRequestConfiguration({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    return await Axios.put(uri, formData.toString(), cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};
